<template>
  <div>
    <admin-sidebar></admin-sidebar>
    <section id="dashboard">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="title">
              <h2>Guest Interventions</h2>
            </div>
          </div>
        </div>
        <div class="w-100">
          <div class="d-block d-xl-flex">
            <div class="col-12 col-xl-3 flex-row m-md-0">
              <div class="row mb-xl-4">
                <ul class="management-btn">
                  <li>
                    <input type="search" placeholder="kerko" :value="searchQuery" @input="onChangeHandler"
                      v-on:keyup.enter="requestSearch" />
                    <button type @click="requestSearch">
                      <i class="fas fa-search"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div>
            <div class="white-background">
              <div class="tabcontent padding-0 tab-style w-auto">
                <table v-if="guestInterventions" class="table table-responsive-xl">
                  <thead>
                    <tr>
                      <th>Emri</th>
                      <th>Telefoni</th>
                      <th>Email</th>
                      <th>Distanca</th>
                      <th>Shoferi</th>
                      <th>Statusi</th>
                      <th>Data e intervenimit</th>
                      <th>Çmimi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="guestInfo in guestInterventions" :key="guestInfo.id">
                      <th>{{ guestInfo.name }}</th>
                      <th>{{ guestInfo.phone_number }}</th>
                      <th>{{ guestInfo.email }}</th>
                      <th>{{ transformDistance(guestInfo.towing_distance) }}</th>
                      <th>{{ guestInfo.driver_name ? guestInfo.driver_name: '--'}}</th>
                      <th>{{ guestInfo.towing_status }}</th>
                      <th>{{ formatDate(guestInfo.towing_created_at) }}</th>
                      <th>{{ guestInfo.payment_amount }} €</th>
                    </tr>
                  </tbody>
                </table>
                <div v-else>Nuk u gjet asnje regjistrim!</div>
              </div>
            </div>
          </div>
        </div>
        <pagination
            :currentPage="currentPage"
            :totalPages="totalPages"
            @update-current-page="getCurrentPage"
        ></pagination>
      </div>
    </section>
  </div>
</template>

<style src="@/assets/admin/css/main.css"></style>

<script>
import AdminSidebar from "../components/admin/AdminSidebar";
import { mapGetters } from "vuex";
import { transformDistance, formatDate } from "../utils";
import Pagination from "@/views/Pagination.vue";

export default {
  name: "AdminGuestInterventions",
  components: {
    AdminSidebar: AdminSidebar,
    Pagination: Pagination
  },
  data() {
    return {
      searchQueryTimeOut: null
    }
  },
  computed: {
    ...mapGetters({
      guestInterventions: "guestInfo/guestInterventions",
      guestInterventionsCount: "guestInfo/guestInterventionsCount",
      currentPage: "guestInfo/currentPage",
      totalPages: "guestInfo/totalPages",
      searchQuery: "guestInfo/searchQuery",
      errors: "guestInfo/errors",
      perPageTotal: "guestInfo/perPageTotal"
    }),
  },
  methods: {
    formatDate,
    transformDistance,
    getCurrentPage(value) {
      this.$store.dispatch("guestInfo/getCurrentPage", value);
    },
    getSearchQuery(e) {
      this.$store.dispatch("guestInfo/getSearchQuery", e.target.value);
    },
    requestSearch() {
      this.$store.dispatch("guestInfo/requestSearch");
    },
    onChangeHandler(e) {
      clearTimeout(this.searchQueryTimeOut);

      this.getSearchQuery(e);

      this.searchQueryTimeOut = setTimeout(() => {
        this.requestSearch();
      }, 500);
    },
  },
  beforeMount() {
    this.$store.dispatch("guestInfo/getGuestInterventions");
  },
};
</script>